import { SharingPlaceCard } from 'app/components/sharing-place-card';
import { Text } from 'app/design/primitives/text';
import type { SharingPlace } from 'app/types/sharing-place';
import { Strategies } from '../../all-listings/components/recommended-listings';
import { DesktopRecommendationSection } from '../../all-listings/components/recommended-listings.large';
import { landingPageLargeStyles as styles } from '../large-styles';
import type { useDesktopLandingData } from '../use-desktop-landing-data';

export function NearestSharingPlaceDiscoverySection({ data }: { data: ReturnType<typeof useDesktopLandingData> }) {
  const { nearestSharingPlaceRecommendations, shouldShowRecommendationSection } = data;
  if (!shouldShowRecommendationSection(nearestSharingPlaceRecommendations, { ignoresFeatureFlag: true })) return null;
  return (
    <DesktopRecommendationSection<SharingPlace>
      strategyProps={{ strategy: Strategies.NearestSharingPlace }}
      recommendationState={nearestSharingPlaceRecommendations}
      recommendations={nearestSharingPlaceRecommendations.recommendations as SharingPlace[] | undefined}
      renderItem={(place) => <SharingPlaceCard place={place} />}
      emptyState={null}
      titleSuffix={<Text style={styles.headerIcon}>🏠</Text>}
    />
  );
}
